import getRenderFunction from 'customForm/util/render'
import { CustomFormAccordionCard } from './CustomFormAccordionCard'

export const addAccordionFormsAndSort = getRenderFunction(CustomFormAccordionCard)
